import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@src/components/Tooltip';
import { PROJECT_TYPE_ICONS } from '@src/constants/project';
import { getProjectTypeKind } from '@src/services/project';
import { calculateElapsedDateTime } from '@src/utils/date';
import { StyledProjectRow } from './index.style';

const TOOLTIP_POPPER_PROPS = {
  popperOptions: {
    modifiers: [{ name: 'offset', options: { offset: [0, -6] } }],
  },
};

// Plain elements rather than Typography: the projects page sets 14/510/24 on
// the title, and no shared variant carries that weight.
const ProjectRow = ({ project }) => {
  const { t } = useTranslation();
  const { icon, label } = PROJECT_TYPE_ICONS[getProjectTypeKind(project)];

  return (
    <StyledProjectRow>
      <Tooltip
        arrow
        title={t(label)}
        placement="top"
        PopperProps={TOOLTIP_POPPER_PROPS}
      >
        <div className="row-icon">
          <img src={icon} alt="" />
        </div>
      </Tooltip>
      <div className="row-text">
        <div className="row-title">{project.title}</div>
        <div className="row-date">
          {calculateElapsedDateTime(project.updatedAt, t)}
        </div>
      </div>
    </StyledProjectRow>
  );
};

export default ProjectRow;
